import { api } from '@/services/api/client';
import { getPaginated, type Paginated } from '@/services/api/paginated';
import type { Announcement, Release, ReleaseListQuery, UpdateReleaseRequest } from './types';

/** Endpoints kept with the feature: nothing outside the release screens calls them. */
const BASE = '/releases';

export const releasesService = {
  list: (query: ReleaseListQuery, signal?: AbortSignal): Promise<Paginated<Release>> =>
    getPaginated<Release>(BASE, { ...query }, signal, 'Could not load releases.'),

  get: (id: string, signal?: AbortSignal): Promise<Release> =>
    api.get<Release>(`${BASE}/${id}`, signal ? { signal } : {}),

  update: (id: string, body: UpdateReleaseRequest): Promise<Release> =>
    api.patch<Release>(`${BASE}/${id}`, body),

  /** Desktops on its channel are offered it from their next update check. */
  release: (id: string): Promise<Release> => api.post<Release>(`${BASE}/${id}/release`, {}),

  withdraw: (id: string): Promise<Release> => api.post<Release>(`${BASE}/${id}/withdraw`, {}),

  announcement: (id: string, signal?: AbortSignal): Promise<Announcement> =>
    api.get<Announcement>(`${BASE}/${id}/announcement`, signal ? { signal } : {}),

  announce: (id: string): Promise<{ sent: number; failed: number }> =>
    api.post<{ sent: number; failed: number }>(`${BASE}/${id}/announce`, {}),
};
